import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';

import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      width: '432px',
      height: '264px',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      background: '#FFFFFF',
      boxShadow: '0px 4px 4px #00000040',
      borderRadius: '4px',
      position: 'absolute',
      zIndex: 10,
    },

    closeButton: {
      zIndex: 10,
      right: 0,
      top: 0,
      position: 'absolute',
    },

    fileUpload: {
      height: '100%',
    },
  },
  {
    name: 'UsersFileDelete',
  },
);
